<template>
  <v-main class="ml-6 mt-3">
    <v-row dense>
      <v-col cols="12">
        <h3>Overview accommodation list</h3>
      </v-col>
    </v-row>
    <v-row>
        <v-col cols="2">
            <date_picker label="Reference D-date"                                 
                            :date="report_params.fromDate"
                            field="fromDate" 
                            icon="mdi-calendar-month-outline"
                            :manual="false" 
                            @updateData="updateData"/> 
        </v-col>
    </v-row>
    <v-row dense class="mt-3">    
        <v-col cols="1">
            <btn_create_excel :report_program="report" :report_request="report_request" :report_params="report_params" :show_progress=true :interval="150"/>
        </v-col> 
    </v-row>
    <navBar title="Ares - Sales partners" :home="true" type="inpt"/>
  </v-main>
</template>

<script>
 import navBar from "@/components/ui/navbars/navbar.vue";
 import btn_create_excel from "@/components/ui/buttons/btn_create_excel.vue";
 import date_picker from '@/components/ui/date_picker.vue';

 export default {
  components: {
    btn_create_excel,
    date_picker,
    navBar,
  },
  data() {
    return {
      report: "ares/json/ares/task/inpt/ovrz/ovrz5.p",      
      report_params: {
        fromDate: '',
      },
      report_request: "ovrz5",
    }
  },
  methods: {
    updateData(data){
        this.report_params[data.field] = data.value;
    },  
  }  
 }

</script> 




